/*
 * The sixteen, in the five columns the design draws.
 *
 * Used by both states. Signed out it is the ecosystem section; signed in it is
 * the whole page body. The only difference is whether a click carries your
 * session — see `handoff`.
 */
import { byGroup, ZodiacProduct } from "../../data/zodiacProducts";
import s from "./landing.module.css";

interface Props {
  products: ZodiacProduct[];
  /** Show the one-line description under each name. Off on the signed-in board. */
  withBlurbs?: boolean;
  /** Given a product href, return where the click should actually go. */
  hrefFor?: (p: ZodiacProduct) => string;
}

export default function ProductGrid({ products, withBlurbs = true, hrefFor }: Props) {
  return (
    <div className={s.groups}>
      {byGroup(products).map((group) => (
        <div className={s.group} key={group.id}>
          <p className={s.groupLabel}>{group.label}</p>

          {group.items.map((p) => {
            const soon = Boolean(p.comingSoon);
            const body = (
              <>
                <img
                  src={`/logos/${p.logo}`}
                  alt=""
                  aria-hidden="true"
                  /* Wall Street's mark is a wordmark, not a glyph — see .markWide */
                  className={`${s.mark} ${p.id === "wallstreet" ? s.markWide : ""}`}
                />
                <span className={s.productText}>
                  <span className={`${s.productName} ${s.display}`}>{p.name}</span>
                  {/*
                    No blurb, no element. Crypto Treasury and xTokens have no
                    copy written yet; the design carries a literal [ONE LINE]
                    placeholder for both. Rendering nothing leaves the gap
                    visible to whoever owns the words. Inventing a plausible
                    sentence is the one thing this estate's conventions forbid.
                  */}
                  {withBlurbs && p.blurb ? (
                    <span className={s.productBlurb}>{p.blurb}</span>
                  ) : null}
                </span>
                {soon ? <span className={s.soonTag}>Soon</span> : null}
              </>
            );

            /* Unreleased products are inert, not links. */
            return soon ? (
              <span className={`${s.product} ${s.productSoon}`} key={p.id}>
                {body}
              </span>
            ) : (
              <a className={s.product} key={p.id} href={hrefFor ? hrefFor(p) : p.href}>
                {body}
              </a>
            );
          })}
        </div>
      ))}
    </div>
  );
}
